import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JsonHttpService } from '../../http/json-http.service';
import { ChangeLogItem } from '../models/change-log-item';
import { ChangeLogRequest, EntityIdentifier } from '../models/change-log-request';

@Injectable({
    providedIn: 'root'
})
export class ChangeLogService {

    constructor(private http: JsonHttpService) { }

    getChangeLogItems(entities: EntityIdentifier[], from?: Date, to?: Date, maxRows?: number): Promise<ChangeLogItem[]> {
        const entityRequest: Partial<ChangeLogRequest> = {
            lookupEntities: entities ? entities.map(e => ({ ...e })) : [],
            fromDate: from,
            toDate: to,
            maxResult: maxRows
        };

        for (const e of entityRequest.lookupEntities) {
            if (!e.entityType.endsWith('Entity')) {
                e.entityType = e.entityType + 'Entity';
            }
            e.entityId = (e.entityId === '') || (e.entityId === null) || (e.entityId === undefined) ? null : e.entityId.toString();
        }

        return this.http.post('/api/changelog/get-changelogs', entityRequest).toPromise();
    }

    getPreviousLogItem(id: any): Promise<ChangeLogItem> {
        const options = { params: new HttpParams().set('changeLogId', `${id}`) };
        return this.http.getTyped<ChangeLogItem>('/api/changelog/get-previous-changelog', options).toPromise();
    }
}
